import { post, postJson, postJson1} from './axios'

const RESOURCE_BASE_PATH = '/mainInfoController'

/***
 * 实时数据
 * @param p
 */
export const getRealTimeData = p => postJson(`${RESOURCE_BASE_PATH}/getRealTimeData`, p)

/***
 * 首页 买家信息 短信软件剩余天数
 * @param p
 */
export const getSoftwareInfo = p => post(`${RESOURCE_BASE_PATH}/getSoftwareInfo`, p)

/***
 * 获取公告信息
 * @param p
 */
export const getNoticeInfo = p => post(`${RESOURCE_BASE_PATH}/getNoticeInfo`, p)

/***
 * 催付效果分析
 * @param p
 */
export const getPaymentResult = p => post(`${RESOURCE_BASE_PATH}/getPaymentResult`, p)

/***
 * 催付效果分析图
 * @param p
 */
export const getPaymentResultMap = p => post(`${RESOURCE_BASE_PATH}/getPaymentResultMap`, p)

/***
 * 首页获取未读短信数量
 * @param p
 */
export const getUnreadNote = p => post(`${RESOURCE_BASE_PATH}/getUnreadNote`, p)

/***
 * 首页banner图信息
 * @param p
 */
export const getBannerPrint = p => post(`${RESOURCE_BASE_PATH}/getBannerPrint`, p)

/***
 * 营销效果分析
 * @param p
 */
export const getMarketingResult = p => post(`${RESOURCE_BASE_PATH}/getMarketingResult`, p)

/***
 * 营销效果分析图表
 * @param p
 */
export const getMarketingResultMap = p => post(`${RESOURCE_BASE_PATH}/getMarketingResultMap`, p)

/***
 * 提交反馈信息
 * @param p
 */
export const addFeedBack = p => post(`${RESOURCE_BASE_PATH}/addFeedBack`, p)

/***
 * 任务订单信息
 * @param p
 */
export const addFeedgetOrderTaskBack = p => post(`${RESOURCE_BASE_PATH}/getOrderTask`, p)



/***
 * 发送验证码
 * @param p
 */
export const sendSmsVerifyCode = p => post('/api/public/sendSmsVerifyCode', p)


/***
 * 更新客户信息（绑定手机号，更新皮肤）
 * @param p
 */
export const updateMainSeller = p => postJson(`${RESOURCE_BASE_PATH}/updateMainSeller`, p)

/**
 * 获取订单任务信息
 * @param p
 */
export const getOrderTask = p => post(`${RESOURCE_BASE_PATH}/getOrderTask`, p)



//更新客户信息
export const updateSellerMobile = p => post(`api/mainInfoController/updateSellerMobile`, p)

//获取弹窗配置
export const getSysConfig = p => post(`api/public/getSysConfig`, p)

//获取提醒剩余短信条数和天数

export const querySellerInfo = p => post(`api/public/querySellerInfo`, p)

//获取滚动数据

export const getROIRanking= p => post(`${RESOURCE_BASE_PATH}/getROIRanking`, p)


// 自动领取首充优惠券
export const firstAlipaySysCouponConfig= p => post(`${RESOURCE_BASE_PATH}/firstAlipaySysCouponConfig`, p)

// 埋点
export const uploadPointData = (p) => postJson1(`/yeion-operate-data/collection/uploadPointData`, p);